const defaultSpacing = {
    default: {
        topSpacing: 0,
        mobileTopSpacing: 0,
        bottomSpacing: 0,
        mobileBottomSpacing: 0,
        btmSpacing: 0,
        mobileBtmSpacing: 0
    },
    //  Module white background ， with title the module
    normal: {
        topSpacing: 10,
        btmSpacing: 50,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15
    },
    //  The module is a picture or a color block
    colorBlock: {
        topSpacing: null,
        btmSpacing: 60,
        mobileTopSpacing: null,
        mobileBtmSpacing: 20
    },
    //  special treatment md-team(multi-column-info-under-img,multi-column-info-over-img)
    restColorBlock: {
        topSpacing: 10,
        btmSpacing: 40,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15
    },
    restNormal: {
        topSpacing: 10,
        btmSpacing: 30,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 15
    },
    brokerListSpacing: {
        topSpacing: 10,
        btmSpacing: 50,
        mobileTopSpacing: 5,
        mobileBtmSpacing: 25
    }
};

import util from '@/common/util';

// type: Object.keys(defaultSpacing)
export default function(type = 'default') {
    return {
        data: function() {
            return {
                fullColumn: false,
                ...defaultSpacing[type]
            };
        },
        computed: {
            isMobileSize() {
                return this.platform.isMobile;
            },
            paddingTop({ topSpacing, mobileTopSpacing }) {
                return this.useSpacing(topSpacing, mobileTopSpacing);
            },
            paddingBottom({ bottomSpacing, mobileBottomSpacing }) {
                return this.useSpacing(bottomSpacing, mobileBottomSpacing);
            },
            marginBottom({ btmSpacing, mobileBtmSpacing }) {
                return this.useSpacing(btmSpacing, mobileBtmSpacing);
            },
            spaceStyle({ paddingTop, paddingBottom, marginBottom }) {
                let temp = {};
                paddingTop && (temp.paddingTop = paddingTop);
                paddingBottom && (temp.paddingBottom = paddingBottom);
                marginBottom && (temp.marginBottom = marginBottom);
                return temp;
            }
        },
        methods: {
            useSpacing(pcVal, mobileVal) {
                let { isMobileSize } = this;
                let ret = pcVal;
                if (isMobileSize) {
                    if (!util.isUndef(mobileVal)) {
                        ret = mobileVal;
                    } else {
                        ret = ret / 2;
                    }
                }
                return ret ? ret + 'px' : '';
            }
        }
    };
}
